(function(){
  var blocks = document.querySelectorAll('[data-fic-variant]');
  function show(id){
    blocks.forEach(function(block){ block.hidden = block.dataset.ficVariant !== String(id); });
  }
  var select = document.querySelector('[data-lhero-variant]') || document.getElementById('pdpVariant');
  if(select){
    show(select.value);
    select.addEventListener('change', function(){ show(select.value); });
  }
  document.addEventListener('grig:variant', function(event){ show(event.detail); });
})();
